import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './grid.min.module.css';
import { applyBootstrapClasses } from './apply-bootstrap-classes';
import { applyClasses, applyProps } from '../shared/js';

const Row = ({ children, ...props }) => {
  return (
    <div
      // eslint-disable-next-line react/prop-types
      className={cn(
        styles.row,
        props.className,
        applyClasses(props, styles.row),
        applyBootstrapClasses(props, styles)
      )}
      {...applyProps(props)}
    >
      {children}
    </div>
  );
};

Row.propTypes = {
  /** The row's columns */
  children: PropTypes.any,
  /** Align Columns along the top of the row */
  alignItemsStart: PropTypes.bool,
  /** Align Columns in the center of the row */
  alignItemsCenter: PropTypes.bool,
  /** Align Columns along the bottom of the row */
  alignItemsEnd: PropTypes.bool,
  /** Justify Columns on the left side of the row */
  justifyContentStart: PropTypes.bool,
  /** Justify Columns in the center of the row */
  justifyContentCenter: PropTypes.bool,
  /** Justify Columns on the right side of the row */
  justifyContentEnd: PropTypes.bool,
  /** Evenly space Columns in the row */
  justifyContentAround: PropTypes.bool,
  /** Evenly space Columns in the row, with no padding on the outer edges */
  justifyContentBetween: PropTypes.bool,
  /** Remove the gutter padding between Columns */
  noGutters: PropTypes.bool,
  /** Custom class name forwarded to the row component */
  className: PropTypes.string,
  /** Custom style object forwarded to the row component */
  style: PropTypes.object,
};

Row.defaultProps = {
  children: undefined,
  alignItemsStart: false,
  alignItemsCenter: false,
  alignItemsEnd: false,
  justifyContentStart: false,
  justifyContentCenter: false,
  justifyContentEnd: false,
  justifyContentAround: false,
  justifyContentBetween: false,
  noGutters: false,
  style: {},
  className: undefined,
};

export default Row;
